import { useState, type FC, useRef } from 'react';

import Icon from 'components/icons/Facillities';
import { Heading, Small } from 'components/text';

import {
  InfoIcon,
  LittleEmperorsIcon,
  SustainabilityIcon,
} from 'components/icons';
import { ModalFS } from 'components/Modal';
import { colorConstants } from 'data/constants';
import styles from './HotelFacilities.module.css';
import { type HotelFacilitiesProps } from './HotelFacilities.types';

const HotelFacilities: FC<HotelFacilitiesProps> = ({ facilities }) => {
  const [open, setOpen] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  // TODO: never define as any. if you know a better way that doesn't block the build, please change it. thanks!
  const ref = useRef(null) as any;
  return (
    <div className={styles.container}>
      {open && (
        <ModalFS open={open} onClose={() => setOpen(false)}>
          <div className={styles.moduleContent}>
            <div className={styles.moduleHeader}>
              <LittleEmperorsIcon
                color={colorConstants.black}
                className={styles.brandIcon}
              />
              <Heading as="h4">Hotel Information</Heading>
            </div>
            {facilities.map((facility, index) =>
              facility.rating ? (
                <div key={index} className={styles.moduleSustainability}>
                  <button
                    className={styles.sustainabilityTitle}
                    onClick={() => {
                      setShowInfo(!showInfo);
                      setTimeout(() => {
                        ref.current.scrollIntoView({
                          behavior: 'smooth',
                          block: 'start',
                        });
                      }, 10);
                    }}
                  >
                    <Small weight="demiBold" color="grey-dark">
                      {facility.title}
                    </Small>
                    <div className={styles.rating}>
                      {[1, 2, 3, 4, 5].map(i => (
                        <SustainabilityIcon
                          key={i}
                          active={
                            facility.rating ? i <= facility.rating : false
                          }
                        />
                      ))}
                    </div>
                    <div className={styles.infoIcon}>
                      <InfoIcon />
                    </div>
                  </button>
                  {showInfo && (
                    <div className={styles.sustainabilityInfo}>
                      <Small weight="regular">
                        To reflect Little Emperors’ dedication to promoting
                        sustainable practices, we’ve created our own rating
                        system based on our hotel partners’ sustainability
                        initiatives.
                      </Small>
                      <Small weight="regular">
                        The system awards hotels a score out of five based on a
                        variety of factors, including recycling, plastics,
                        electric vehicles, renewables, locally sourcing food and
                        materials, and charitable commitments.
                      </Small>
                    </div>
                  )}
                  <ul className={styles.moduleDescription} ref={ref}>
                    {facility.description.map((description, index) => (
                      <li key={index}>
                        <Small weight="regular">{description}</Small>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div key={index} className={styles.moduleFacilities}>
                  <Small weight="demiBold" color="grey-dark">
                    {facility.title}
                  </Small>
                  <ul className={styles.moduleDescription}>
                    {facility.description.map((description, index) => (
                      <li key={index}>
                        <Small weight="regular">{description}</Small>
                      </li>
                    ))}
                  </ul>
                </div>
              )
            )}
          </div>
        </ModalFS>
      )}
      <Heading as="h5">Hotel Information</Heading>
      <div className={styles.facilitiesList}>
        {facilities.map((facility, index) => (
          <div
            key={index}
            className={styles.facilities}
            onClick={() => setOpen(true)}
          >
            <div className={styles.icon}>
              <Icon name={facility.icon_name} />
            </div>
            <div className={styles.descriptionContainer}>
              <div className={styles.description}>
                <Small weight="demiBold" color="grey-dark">
                  {facility.title}
                </Small>
                {facility.icon_name === 'sustainability' ? (
                  <Small weight="regular" key={index}>
                    {facility.description[0].split(' ').slice(0, 10).join(' ') +
                      (facility.description[0].split(' ').length > 10
                        ? '...'
                        : '')}
                  </Small>
                ) : (
                  <div className={styles.descriptionPoints}>
                    {facility.description.map(
                      (description, index) =>
                        index < 2 && (
                          <Small weight="regular" key={index}>
                            {description}
                            <br />
                          </Small>
                        )
                    )}
                  </div>
                )}
              </div>
              {(facility.description.length > 2 ||
                facility.icon_name === 'sustainability') && (
                <Small weight="demiBold">
                  <u>more</u>
                </Small>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HotelFacilities;
